import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/filterIconDisabled.svg'
import _imports_1 from '@/assets/filterIcon.svg'
import _imports_2 from '@/assets/leftArrowFilled.svg'
import _imports_3 from '@/assets/rightArrowFilled.svg'
import _imports_4 from '@/assets/cancel.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-0e83eaac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "flex justify-between items-center h-8" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex flex-row-reverse items-center" }
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_9 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_11 = { class: "mt-5 bg-white border border-lightgrey relative rounded" }
const _hoisted_12 = { class: "px-5 pb-5 pt-5 w-full h-full" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "group-buttons"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "arrow left-0"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "arrow right-0"
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "arrow left-0"
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "arrow right-0"
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progressbarB rounded h-1" }, null, -1))
const _hoisted_26 = { class: "w-full" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "py-2 noScrollbar tabStructure1 overflow-y-auto" }
const _hoisted_29 = { class: "formcontainer flex flex-col" }
const _hoisted_30 = { class: "row flex flex-row w-full gap-3" }
const _hoisted_31 = { class: "w-1/2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-xs" }, "Activity Name", -1))
const _hoisted_33 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_34 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_35 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_36 = {
  key: 2,
  class: "invalid-feedback text-xs"
}
const _hoisted_37 = { class: "w-1/2" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-xs" }, "Criticality", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  hidden: ""
}, "Please select one", -1))
const _hoisted_40 = ["value"]
const _hoisted_41 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_42 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_43 = { class: "row flex flex-row upperspacing w-full gap-3" }
const _hoisted_44 = { class: "w-1/2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-xs" }, "Team", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "No departments Found", -1))
const _hoisted_47 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_48 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_49 = { class: "upperspacing w-full" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-xs" }, "Description", -1))
const _hoisted_51 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_52 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_53 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_54 = {
  key: 1,
  class: "pt-3 noScrollbar tabStructure1 overflow-y-auto"
}
const _hoisted_55 = { class: "tableCornerRadius" }
const _hoisted_56 = { class: "table-container noScrollbar" }
const _hoisted_57 = { class: "header cursor-pointer w-4" }
const _hoisted_58 = { class: "flex items-center w-4 mx-2" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = {
  key: 0,
  class: "pl-5"
}
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_65 = ["onUpdate:modelValue"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select", -1))
const _hoisted_67 = ["value"]
const _hoisted_68 = ["onUpdate:modelValue"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select", -1))
const _hoisted_70 = ["value"]
const _hoisted_71 = ["onUpdate:modelValue"]
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { class: "cursor-pointer rowHeight" }
const _hoisted_74 = ["colspan"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
], -1))
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = {
  key: 1,
  class: "nonEmptyTable"
}
const _hoisted_78 = ["value"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { key: 1 }
const _hoisted_82 = { key: 2 }
const _hoisted_83 = { class: "table-ellipsis" }
const _hoisted_84 = ["onMousemove"]
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = {
  key: 2,
  class: "pt-3 noScrollbar tabStructure1 overflow-y-auto"
}
const _hoisted_88 = { class: "tableCornerRadius" }
const _hoisted_89 = { class: "table-container noScrollbar" }
const _hoisted_90 = { class: "header cursor-pointer w-4" }
const _hoisted_91 = { class: "flex items-center w-4 mx-2" }
const _hoisted_92 = ["disabled"]
const _hoisted_93 = ["onClick"]
const _hoisted_94 = {
  key: 0,
  class: "pl-5"
}
const _hoisted_95 = { key: 1 }
const _hoisted_96 = { key: 0 }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_98 = ["onUpdate:modelValue"]
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select", -1))
const _hoisted_100 = ["value"]
const _hoisted_101 = ["onUpdate:modelValue"]
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select", -1))
const _hoisted_103 = ["value"]
const _hoisted_104 = ["onUpdate:modelValue"]
const _hoisted_105 = { key: 0 }
const _hoisted_106 = { class: "cursor-pointer rowHeight" }
const _hoisted_107 = ["colspan"]
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
], -1))
const _hoisted_109 = [
  _hoisted_108
]
const _hoisted_110 = {
  key: 1,
  class: "nonEmptyTable"
}
const _hoisted_111 = ["value"]
const _hoisted_112 = ["onClick"]
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { key: 1 }
const _hoisted_115 = { key: 2 }
const _hoisted_116 = { class: "table-ellipsis" }
const _hoisted_117 = ["onMousemove"]
const _hoisted_118 = { key: 0 }
const _hoisted_119 = { key: 0 }
const _hoisted_120 = {
  key: 0,
  class: "bottom-7 bg-white h-14 flex justify-end items-center w-full rounded-b-sm",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_121 = { class: "buttonposition flex justify-end items-center px-5 mx-5" }
const _hoisted_122 = ["disabled"]
const _hoisted_123 = ["disabled"]
const _hoisted_124 = {
  key: 1,
  class: "bottom-7 bg-white h-14 flex justify-end items-center w-full rounded-b-sm",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_125 = { class: "buttonposition flex justify-end items-center px-5 mx-5" }
const _hoisted_126 = ["disabled"]
const _hoisted_127 = ["disabled"]
const _hoisted_128 = {
  key: 2,
  class: "bottom-7 bg-white h-14 flex justify-end items-center w-full rounded-b-sm",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_129 = { class: "buttonposition flex justify-end items-center px-5 mx-5" }
const _hoisted_130 = ["disabled"]
const _hoisted_131 = ["disabled"]
const _hoisted_132 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_133 = {
  key: 0,
  class: "pl-2"
}
const _hoisted_134 = {
  key: 1,
  class: "pl-2"
}
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "h-5 w-5 cursor-pointer"
}, null, -1))
const _hoisted_136 = [
  _hoisted_135
]
const _hoisted_137 = { class: "pl-4 pb-4 pr-4" }
const _hoisted_138 = { class: "w-full mt-3" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "Control Title", -1))
const _hoisted_140 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_141 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_142 = { class: "flex mt-3" }
const _hoisted_143 = { class: "w-1/2" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "CCID", -1))
const _hoisted_145 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_146 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_147 = { class: "w-1/2" }
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "Control Frequency", -1))
const _hoisted_149 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_150 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_151 = { class: "flex mt-3" }
const _hoisted_152 = { class: "w-1/2" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "Control Number", -1))
const _hoisted_154 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_155 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_156 = { class: "w-1/2" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "Control Class", -1))
const _hoisted_158 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_159 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_160 = { class: "flex mt-3" }
const _hoisted_161 = { class: "w-1/2" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "Owner", -1))
const _hoisted_163 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_164 = { key: 1 }
const _hoisted_165 = { class: "w-1/2" }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "Priority", -1))
const _hoisted_167 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_168 = { class: "flex mt-3" }
const _hoisted_169 = { class: "w-1/2" }
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "Control Family", -1))
const _hoisted_171 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_172 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_173 = { class: "w-1/2" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "Control Type", -1))
const _hoisted_175 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_176 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_177 = { class: "w-full mt-3" }
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "Control Guidance", -1))
const _hoisted_179 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_180 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_181 = { class: "w-full mt-3" }
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "Audit Methodology", -1))
const _hoisted_183 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_184 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_185 = { class: "w-full mt-3" }
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "Audit Success Criteria", -1))
const _hoisted_187 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_188 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_189 = { class: "w-full mt-3" }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "Policies", -1))
const _hoisted_191 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_192 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_193 = { class: "w-full mt-3" }
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "Maintenance Task", -1))
const _hoisted_195 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_196 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_197 = { class: "w-full mt-3" }
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "FrameWork", -1))
const _hoisted_199 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_200 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_201 = { class: "w-full mt-3" }
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controllabel" }, "Controls", -1))
const _hoisted_203 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_204 = {
  key: 1,
  class: "text-sm mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        (_ctx.activitiesObj != undefined || _ctx.activitiesObj != null)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.activitiesObj.name), 1))
          : (_openBlock(), _createElementBlock("h1", _hoisted_5, "Activity"))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.selectedTabIndex == 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(["flex items-center", _ctx.activeControlsListDisplay.length == 0 ? 'btndisabled pointer-events-none':'filterButton']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filtersOpen()))
            }, [
              (_ctx.activeControlsListDisplay.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : (_openBlock(), _createElementBlock("img", _hoisted_8)),
              _createTextVNode(" Filters ")
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.selectedTabIndex == 2)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: _normalizeClass(["flex items-center", _ctx.allControlsListDisplay.length == 0 ? 'btndisabled pointer-events-none':'filterButton']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filtersOpen()))
            }, [
              (_ctx.allControlsListDisplay.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : (_openBlock(), _createElementBlock("img", _hoisted_10)),
              _createTextVNode(" Filters ")
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (_ctx.screenReduced)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_ctx.isSmallScreen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["absolute left-0 top-5 cursor-pointer", { 'disabled pointer-events-none': (_ctx.selectedTabIndex === 0 || _ctx.currentGroupIndex === 0) && _ctx.isSmallScreen }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollTabs('left')))
                    }, _hoisted_16, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["absolute right-0 top-5 cursor-pointer", { 'disabled pointer-events-none': (_ctx.selectedTabIndex === _ctx.carouselHead.length - 1 || _ctx.currentGroupIndex >= _ctx.totalGroups - 1) && _ctx.isSmallScreen }]),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollTabs('right')))
                    }, _hoisted_18, 2)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["absolute left-0 top-5 cursor-pointer", { 'disabled pointer-events-none': !_ctx.canScrollLeft && !_ctx.isSmallScreen }]),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollTabs('left')))
                    }, _hoisted_21, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["absolute right-0 top-5 cursor-pointer", { 'disabled pointer-events-none': !_ctx.canScrollRight && !_ctx.isSmallScreen }]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.scrollTabs('right')))
                    }, _hoisted_23, 2)
                  ]))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "flex flex-row borderBottom cursor-pointer tab-container",
              ref: "tabContainer",
              onScroll: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["pb-1", _ctx.selectedTabIndex == tab.id ? 'adjust header text-sm font-semibold selectedTabText':'text-sm text-disabledgrey']),
                  key: index,
                  onClick: ($event: any) => (_ctx.toggleTabs(tab))
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      ref_for: true,
                      ref: "actualIndex",
                      class: "cursor-pointer tabtextstyle"
                    }, _toDisplayString(tab.displayName), 513),
                    _createElementVNode("div", {
                      class: _normalizeClass([{ progress: _ctx.selectedTabIndex === tab.id }, "h-1 p-0.75 relative rounded"])
                    }, null, 2)
                  ])
                ], 10, _hoisted_24))
              }), 128))
            ], 544)
          ]),
          _hoisted_25
        ]),
        _createElementVNode("div", _hoisted_26, [
          (_ctx.selectedTabIndex == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': (_ctx.v$.activitiesObj.name.$error || _ctx.checkActivityName)}]),
                          placeholder: "Activity Name",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.activitiesObj.name) = $event)),
                          onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.activitiesObj.name.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.activitiesObj.name,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.activitiesObj.name.$error || _ctx.checkActivityName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              (_ctx.v$.activitiesObj.name.required.$invalid )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Required"))
                                : (_ctx.v$.activitiesObj.name.required && _ctx.v$.activitiesObj.name.restrictCharacters50.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, "Charcter Limit is exceeded"))
                                  : (_ctx.checkActivityName)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Activity Name already exists."))
                                    : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _withDirectives(_createElementVNode("select", {
                          class: _normalizeClass(["", {
                                            'is-invalid': _ctx.v$.activitiesObj.criticality.$error,'inputboxstylingForSelectAtPopup': _ctx.activitiesObj.criticality === '','stylingForInputboxstylingForSelectAtPopup': _ctx.activitiesObj.criticality !== ''
                                        }]),
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.activitiesObj.criticality) = $event))
                        }, [
                          _hoisted_39,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criticalityoptions, (option) => {
                            return (_openBlock(), _createElementBlock("option", {
                              class: "optionColors",
                              key: option.id,
                              value: option.id
                            }, _toDisplayString(option.value), 9, _hoisted_40))
                          }), 128))
                        ], 2), [
                          [_vModelSelect, _ctx.activitiesObj.criticality]
                        ]),
                        (_ctx.v$.activitiesObj.criticality.$error )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              (_ctx.v$.activitiesObj.criticality.required.$invalid )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createVNode(_component_multiselect, {
                          modelValue: _ctx.activitiesObj.departments,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.activitiesObj.departments) = $event)),
                          options: _ctx.teamsOptions,
                          showNoOptions: false,
                          onSearchChange: _ctx.asyncdepartmentDisplayFind,
                          multiple: false,
                          label: "label",
                          "track-by": "value",
                          searchable: true,
                          "close-on-select": true,
                          "show-labels": false,
                          "hide-selected": true,
                          placeholder: "Team",
                          "open-direction": "bottom",
                          class: _normalizeClass(["custom-multiselect userSelect", {
                                            'is-invalidmultiselect': _ctx.v$.activitiesObj.departments.$error,
                                            'has-options': _ctx.teamsOptions && _ctx.teamsOptions.length > 0,
                                            'no-options': !_ctx.teamsOptions.length,
                                        }])
                        }, {
                          noResult: _withCtx(() => [
                            _hoisted_46
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "onSearchChange", "class"]),
                        (_ctx.v$.activitiesObj.departments.$error )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              (_ctx.v$.activitiesObj.departments.required.$invalid )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, "Required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _withDirectives(_createElementVNode("textarea", {
                        class: _normalizeClass(["inputboxstyling", {
                                            'is-invalid': _ctx.v$.activitiesObj.description.$error
                                        }]),
                        placeholder: "Description",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.activitiesObj.description) = $event)),
                        onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.v$.activitiesObj.description.$touch()))
                      }, null, 34), [
                        [
                          _vModelText,
                          _ctx.activitiesObj.description,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.activitiesObj.description.$error )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                            (_ctx.v$.activitiesObj.description.required.$invalid )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, "Required"))
                              : (_ctx.v$.activitiesObj.description.required && _ctx.v$.activitiesObj.description.restrictCharacters.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_53, "Charcter Limit is exceeded"))
                                : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedTabIndex == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("table", null, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("th", _hoisted_57, [
                          _createElementVNode("div", _hoisted_58, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectAllOptionActiveControls) = $event)),
                              class: "checkbox cursor-pointer",
                              disabled: _ctx.allControlsList.length == 0,
                              onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectAllActiveControls($event)))
                            }, null, 40, _hoisted_59), [
                              [_vModelCheckbox, _ctx.selectAllOptionActiveControls]
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeControlHeaders, (column) => {
                          return (_openBlock(), _createElementBlock("th", {
                            scope: "col",
                            onClick: ($event: any) => (_ctx.sort(column)),
                            class: _normalizeClass([_ctx.getHeaderProperties0('width',column), "bg-white capitalize"]),
                            key: column
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex items-center", _ctx.getHeaderProperties0('widthInner',column)])
                            }, [
                              (column == 'controlPriority')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString('Priority')))
                                : (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(_ctx.getHeaderProperties0('name',column)), 1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                              }, null, 2)
                            ], 2)
                          ], 10, _hoisted_60))
                        }), 128)),
                        (_ctx.showFilters)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_63, [
                              _hoisted_64,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeControlHeaders, (name, index) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  class: "bg-white",
                                  key: index
                                }, [
                                  (name == 'controlPriority')
                                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                        key: 0,
                                        class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                      }, [
                                        _hoisted_66,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbPriority, (pair) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: pair,
                                            value: pair.value
                                          }, _toDisplayString(pair.key), 9, _hoisted_67))
                                        }), 128))
                                      ], 10, _hoisted_65)), [
                                        [_vModelSelect, _ctx.allFilters[name]]
                                      ])
                                    : (name == 'controlFrequency')
                                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                          key: 1,
                                          class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                        }, [
                                          _hoisted_69,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbFrequency, (pair) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: pair,
                                              value: pair.value
                                            }, _toDisplayString(pair.key), 9, _hoisted_70))
                                          }), 128))
                                        ], 10, _hoisted_68)), [
                                          [_vModelSelect, _ctx.allFilters[name]]
                                        ])
                                      : _withDirectives((_openBlock(), _createElementBlock("input", {
                                          key: 2,
                                          type: "text",
                                          class: "searchForInputBoxStyling filter-font-size",
                                          placeholder: "Search",
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                        }, null, 8, _hoisted_71)), [
                                          [_vModelText, _ctx.allFilters[name]]
                                        ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.sortedDataActiveControls.length == 0)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_72, [
                            _createElementVNode("tr", _hoisted_73, [
                              _createElementVNode("td", {
                                class: "relative h-10",
                                colspan: _ctx.activeControlHeaders.length+1
                              }, _hoisted_76, 8, _hoisted_74)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_77, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDataActiveControls, (dataObj, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: index,
                                class: "cursor-pointer rowHeight"
                              }, [
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "checkbox mx-2",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.checkedActiveControls) = $event)),
                                    onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.changedActiveControlInput())),
                                    value: dataObj._id
                                  }, null, 40, _hoisted_78), [
                                    [_vModelCheckbox, _ctx.checkedActiveControls]
                                  ])
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeControlHeaders, (column) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    scope: "col",
                                    onClick: ($event: any) => (_ctx.displayRowData(dataObj)),
                                    onMouseout: _cache[17] || (_cache[17] = ($event: any) => (_ctx.doFalse())),
                                    key: column
                                  }, [
                                    (column == 'controlFrequency')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                          _createElementVNode("div", null, _toDisplayString(_ctx.getFrequencyValue( dataObj['controlFrequency'] )), 1)
                                        ]))
                                      : (column == 'controlPriority')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.colorLabelBg(dataObj[column])])
                                            }, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(_ctx.colorLabelText(dataObj[column]))
                                              }, _toDisplayString(_ctx.getProirityLabel(dataObj[column])), 3)
                                            ], 2)
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                            _createElementVNode("div", _hoisted_83, [
                                              _createElementVNode("p", {
                                                class: "fullText",
                                                onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, dataObj, 'text'))
                                              }, _toDisplayString(dataObj[column]), 41, _hoisted_84)
                                            ])
                                          ]))
                                  ], 40, _hoisted_79))
                                }), 128))
                              ]))
                            }), 128))
                          ]))
                    ])
                  ]),
                  (_ctx.sortedDataActiveControls.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                        _createVNode(_component_pagination, {
                          dynamicPagination: _ctx.dynamicPagination,
                          onCurrentPageUpdate: _ctx.paginationUpdations,
                          sortedData: _ctx.sortedDataActiveControls
                        }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.toolTipActive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                      _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.selectedTabIndex == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("table", null, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("th", _hoisted_90, [
                            _createElementVNode("div", _hoisted_91, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selectAllOptionAllControls) = $event)),
                                class: "checkbox cursor-pointer",
                                disabled: _ctx.allControlsList.length == 0,
                                onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.selectAllAllControls($event)))
                              }, null, 40, _hoisted_92), [
                                [_vModelCheckbox, _ctx.selectAllOptionAllControls]
                              ])
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allControlHeaders, (column) => {
                            return (_openBlock(), _createElementBlock("th", {
                              scope: "col",
                              onClick: ($event: any) => (_ctx.sort(column)),
                              class: _normalizeClass([_ctx.getHeaderProperties1('width',column), "bg-white capitalize"]),
                              key: column
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["flex items-center", _ctx.getHeaderProperties1('widthInner',column)])
                              }, [
                                (column == 'controlPriority')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString('Priority')))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_95, _toDisplayString(_ctx.getHeaderProperties1('name',column)), 1)),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                                }, null, 2)
                              ], 2)
                            ], 10, _hoisted_93))
                          }), 128)),
                          (_ctx.showFilters)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_96, [
                                _hoisted_97,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allControlHeaders, (name, index) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    class: "bg-white",
                                    key: index
                                  }, [
                                    (name == 'controlPriority')
                                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                          key: 0,
                                          class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                        }, [
                                          _hoisted_99,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbPriority, (pair) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: pair,
                                              value: pair.value
                                            }, _toDisplayString(pair.key), 9, _hoisted_100))
                                          }), 128))
                                        ], 10, _hoisted_98)), [
                                          [_vModelSelect, _ctx.allFilters[name]]
                                        ])
                                      : (name == 'controlFrequency')
                                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                            key: 1,
                                            class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                          }, [
                                            _hoisted_102,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbFrequency, (pair) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: pair,
                                                value: pair.value
                                              }, _toDisplayString(pair.key), 9, _hoisted_103))
                                            }), 128))
                                          ], 10, _hoisted_101)), [
                                            [_vModelSelect, _ctx.allFilters[name]]
                                          ])
                                        : _withDirectives((_openBlock(), _createElementBlock("input", {
                                            key: 2,
                                            type: "text",
                                            class: "searchForInputBoxStyling filter-font-size",
                                            placeholder: "Search",
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                          }, null, 8, _hoisted_104)), [
                                            [_vModelText, _ctx.allFilters[name]]
                                          ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.sortedDataAllControls.length == 0)
                          ? (_openBlock(), _createElementBlock("tbody", _hoisted_105, [
                              _createElementVNode("tr", _hoisted_106, [
                                _createElementVNode("td", {
                                  class: "relative h-10",
                                  colspan: _ctx.allControlHeaders.length + 1
                                }, _hoisted_109, 8, _hoisted_107)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("tbody", _hoisted_110, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDataAllControls, (controlObject, index) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: index,
                                  class: "cursor-pointer rowHeight"
                                }, [
                                  _createElementVNode("td", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "checkbox mx-2",
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.checkedAllControls) = $event)),
                                      onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.changedAllControlInput())),
                                      value: controlObject._id
                                    }, null, 40, _hoisted_111), [
                                      [_vModelCheckbox, _ctx.checkedAllControls]
                                    ])
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allControlHeaders, (column) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      scope: "col",
                                      onMouseout: _cache[22] || (_cache[22] = ($event: any) => (_ctx.doFalse())),
                                      key: column,
                                      onClick: ($event: any) => (_ctx.displayRowData(controlObject))
                                    }, [
                                      (column == 'controlFrequency')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                            _createElementVNode("div", null, _toDisplayString(_ctx.getFrequencyValue( controlObject[column] )), 1)
                                          ]))
                                        : (column == 'controlPriority')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.colorLabelBg(controlObject[column])])
                                              }, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(_ctx.colorLabelText(controlObject[column]))
                                                }, _toDisplayString(_ctx.getProirityLabel(controlObject[column])), 3)
                                              ], 2)
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                              _createElementVNode("div", _hoisted_116, [
                                                _createElementVNode("p", {
                                                  class: "fullText",
                                                  onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, controlObject, 'text'))
                                                }, _toDisplayString(controlObject[column]), 41, _hoisted_117)
                                              ])
                                            ]))
                                    ], 40, _hoisted_112))
                                  }), 128))
                                ]))
                              }), 128))
                            ]))
                      ])
                    ]),
                    (_ctx.sortedDataAllControls.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                          _createVNode(_component_pagination, {
                            dynamicPagination: _ctx.dynamicPagination,
                            onCurrentPageUpdate: _ctx.paginationUpdations,
                            sortedData: _ctx.sortedDataAllControls
                          }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.toolTipActive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                        _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.selectedTabIndex == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
            _createElementVNode("div", _hoisted_121, [
              _createElementVNode("button", {
                class: _normalizeClass(["mr-1.5", (JSON.stringify(_ctx.dummyactivitiesObj) == JSON.stringify(_ctx.activitiesObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                disabled: _ctx.clickOnButton,
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onCancelbtn()))
              }, "Cancel", 10, _hoisted_122),
              _createElementVNode("button", {
                class: _normalizeClass(["", (JSON.stringify(_ctx.dummyactivitiesObj) == JSON.stringify(_ctx.activitiesObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                disabled: _ctx.clickOnButton,
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onClickUpdateBtn(_ctx.activitiesObj)))
              }, "Save", 10, _hoisted_123)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedTabIndex == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
            _createElementVNode("div", _hoisted_125, [
              _createElementVNode("button", {
                class: _normalizeClass(["btnprimary mr-1.5", _ctx.arraysAreEqual ? 'btndisabled pointer-events-none' : 'btnprimary']),
                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.cancelActiveControls())),
                disabled: _ctx.clickOnButton
              }, "Cancel", 10, _hoisted_126),
              _createElementVNode("button", {
                class: _normalizeClass(["btnprimary", _ctx.arraysAreEqual ? 'btndisabled pointer-events-none' : 'btnprimary']),
                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.changeActiveControlsToActivity(10303))),
                disabled: _ctx.clickOnButton
              }, "Save", 10, _hoisted_127)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedTabIndex == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
            _createElementVNode("div", _hoisted_129, [
              _createElementVNode("button", {
                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onCancelAllControls())),
                class: _normalizeClass([_ctx.checkedAllControls.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary mr-1.5"]),
                disabled: _ctx.onClickActivityButton
              }, "Cancel", 10, _hoisted_130),
              _createElementVNode("button", {
                onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.mapTheSelectedControlsToActivity(10301))),
                class: _normalizeClass([_ctx.checkedAllControls.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary"]),
                disabled: _ctx.onClickActivityButton
              }, "Save", 10, _hoisted_131)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showControlDetailsPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.showControlDetailsPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_132, [
              (_ctx.selectedTabIndex == 1)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_133, "Mandatory Control"))
                : (_openBlock(), _createElementBlock("h1", _hoisted_134, "Control")),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.onCancelbtnPopup()))
              }, _hoisted_136)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", _hoisted_137, [
                  _createElementVNode("div", _hoisted_138, [
                    _hoisted_139,
                    (_ctx.controlDetailsObject.controlTitle != undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_140, _toDisplayString(_ctx.controlDetailsObject.controlTitle), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_141, "N/A"))
                  ]),
                  _createElementVNode("div", _hoisted_142, [
                    _createElementVNode("div", _hoisted_143, [
                      _hoisted_144,
                      (_ctx.controlDetailsObject.clientUniqueId != undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_145, _toDisplayString(_ctx.controlDetailsObject.clientUniqueId), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_146, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_147, [
                      _hoisted_148,
                      (_ctx.controlDetailsObject.controlFrequency != undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_149, _toDisplayString(_ctx.getControlFrequency(_ctx.controlDetailsObject.controlFrequency)), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_150, "N/A"))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_151, [
                    _createElementVNode("div", _hoisted_152, [
                      _hoisted_153,
                      (_ctx.controlDetailsObject.controlNumber != undefined && _ctx.controlDetailsObject.controlNumber != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_154, _toDisplayString(_ctx.controlDetailsObject.controlNumber), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_155, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_156, [
                      _hoisted_157,
                      (_ctx.controlDetailsObject.controlClass != undefined && _ctx.controlDetailsObject.controlClass != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_158, _toDisplayString(_ctx.controlDetailsObject.controlClass), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_159, "N/A"))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_160, [
                    _createElementVNode("div", _hoisted_161, [
                      _hoisted_162,
                      (_ctx.controlDetailsObject.owner != undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_163, _toDisplayString(_ctx.controlDetailsObject.owner), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_164, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_165, [
                      _hoisted_166,
                      (_ctx.controlDetailsObject.controlPriority && typeof _ctx.controlDetailsObject.controlPriority === 'number')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["rounded h-5 w-24 mt-2", _ctx.colorLabelBg(_ctx.controlDetailsObject.controlPriority)])
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex items-center justify-center text-xs", _ctx.colorLabelText(_ctx.controlDetailsObject.controlPriority)])
                            }, _toDisplayString(_ctx.getProirityLabel(_ctx.controlDetailsObject.controlPriority)), 3)
                          ], 2))
                        : (_openBlock(), _createElementBlock("div", _hoisted_167, "N/A"))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_168, [
                    _createElementVNode("div", _hoisted_169, [
                      _hoisted_170,
                      (_ctx.controlDetailsObject.controlFamily != undefined && _ctx.controlDetailsObject.controlFamily != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_171, _toDisplayString(_ctx.controlDetailsObject.controlFamily), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_172, "N/A"))
                    ]),
                    _createElementVNode("div", _hoisted_173, [
                      _hoisted_174,
                      (_ctx.controlDetailsObject.controlType != undefined && _ctx.controlDetailsObject.controlType != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_175, _toDisplayString(_ctx.controlDetailsObject.controlType), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_176, "N/A"))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_177, [
                    _hoisted_178,
                    (Object.keys(_ctx.controlDetailsObject).includes('controlGuidance') && (_ctx.controlDetailsObject.controlGuidance != undefined && _ctx.controlDetailsObject.controlGuidance != '' && _ctx.controlDetailsObject.controlGuidance != null))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_179, _toDisplayString(_ctx.controlDetailsObject.controlGuidance), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_180, "N/A"))
                  ]),
                  _createElementVNode("div", _hoisted_181, [
                    _hoisted_182,
                    (Object.keys(_ctx.controlDetailsObject).includes('controlAuditMethodology') && (_ctx.controlDetailsObject.controlAuditMethodology != undefined && _ctx.controlDetailsObject.controlAuditMethodology != '' && _ctx.controlDetailsObject.controlAuditMethodology != null))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_183, _toDisplayString(_ctx.controlDetailsObject.controlAuditMethodology), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_184, "N/A"))
                  ]),
                  _createElementVNode("div", _hoisted_185, [
                    _hoisted_186,
                    (Object.keys(_ctx.controlDetailsObject).includes('controlAuditSuccessCriteria') && (_ctx.controlDetailsObject.controlAuditSuccessCriteria != undefined && _ctx.controlDetailsObject.controlAuditSuccessCriteria != '' && _ctx.controlDetailsObject.controlAuditSuccessCriteria != null))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_187, _toDisplayString(_ctx.controlDetailsObject.controlAuditSuccessCriteria), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_188, "N/A"))
                  ]),
                  _createElementVNode("div", _hoisted_189, [
                    _hoisted_190,
                    (Object.keys(_ctx.controlDetailsObject).includes('controlPolicies') && (_ctx.controlDetailsObject.controlPolicies != undefined && _ctx.controlDetailsObject.controlPolicies != '' && _ctx.controlDetailsObject.controlPolicies != null))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_191, _toDisplayString(_ctx.controlDetailsObject.controlPolicies), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_192, "N/A"))
                  ]),
                  _createElementVNode("div", _hoisted_193, [
                    _hoisted_194,
                    (Object.keys(_ctx.controlDetailsObject).includes('controlMaintenanceTask') && (_ctx.controlDetailsObject.controlMaintenanceTask != undefined && _ctx.controlDetailsObject.controlMaintenanceTask != '' && _ctx.controlDetailsObject.controlMaintenanceTask != null))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_195, _toDisplayString(_ctx.controlDetailsObject.controlMaintenanceTask), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_196, "N/A"))
                  ]),
                  _createElementVNode("div", _hoisted_197, [
                    _hoisted_198,
                    (Object.keys(_ctx.controlDetailsObject).includes('controlOptionFrameWork') && (_ctx.controlDetailsObject.controlOptionFrameWork != undefined && _ctx.controlDetailsObject.controlOptionFrameWork != '' && _ctx.controlDetailsObject.controlOptionFrameWork != null))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_199, _toDisplayString(_ctx.controlDetailsObject.controlOptionFrameWork), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_200, "N/A"))
                  ]),
                  _createElementVNode("div", _hoisted_201, [
                    _hoisted_202,
                    (Object.keys(_ctx.controlDetailsObject).includes('frameworkControls') && (_ctx.controlDetailsObject.frameworkControls != undefined && _ctx.controlDetailsObject.frameworkControls != '' && _ctx.controlDetailsObject.frameworkControls != null))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_203, _toDisplayString(_ctx.controlDetailsObject.frameworkControls), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_204, "N/A"))
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}